export default __webpack_public_path__ + "static/media/undraw_Dev_focus_re_6iwt.e9dc171a.svg";